import {
  MaybeOriginOrderArrayZodSchema,
  ReturnZodSchema,
} from "@redotech/redo-model/return";
import { ReturnBearCaseMethodType } from "@redotech/returnbear-model/shared/common-enums";
import { sinkValue } from "@redotech/util/type";
import * as z from "zod";

// Needed for type resolution
sinkValue(ReturnBearCaseMethodType);

export enum GetReturnErrorCode {
  ReturnNotFound = "ReturnNotFound",
}
export const getReturn = {
  name: "getReturn" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({
    return: ReturnZodSchema,
    originOrders: MaybeOriginOrderArrayZodSchema,
    loyaltyData: z.object({
      enabled: z.boolean(),
      pointsPerDollar: z.number(),
      currentPoints: z.number(),
      loyaltyPointsRedeemedOnOrder: z.number(),
      lineItemPointsEarned: z.record(z.string(), z.number()),
    }),
  }),
};
